export default __webpack_public_path__ + "static/video-boat-9e7093b67d24e4302f024e364f2e099f.mp4";